module.exports = __webpack_public_path__ + "static/media/tick.32cb4523.png";